<template>
  <div class="rj-page-card">
    <div class="title">
      详细信息
    </div>
    <div class="search-box-line">
      <el-tooltip content="请至少选中两条项目" placement="top-start">
        <div class="icon">
          <i class="el-icon-warning-outline" />
        </div>
      </el-tooltip>
      <el-date-picker
        v-model="wantSetTime"
        type="date"
        class="input-width"
        value-format="yyyy-MM-dd"
        placeholder="选择变更日期"
        :disabled="multipleSelection.length < 2 || !changeType"
        :picker-options="{
          disabledDate: (current) => defaultDisabledDay(current),
        }"
      />
      <el-button
        :disabled="multipleSelection.length < 2 || !changeType"
        type="primary"
        @click="handleSetTime"
      >
        设置
      </el-button>
      <span v-if="isAdvance" class="tooltips">客期变更标准：变更类型为提前时，提前后的客期需大于(申请日+7天)，且小于当前客期的工作日</span>
      <span v-if="isDelay" class="tooltips">客期变更标准：变更类型为延迟时，延迟后的客期需大于当前客期的工作日。</span>
    </div>
    <el-table
      ref="table"
      border
      :data="tableData"
      :row-key="(row) => row.orderRowId"
      max-height="500"
      highlight-selection-row
      highlight-current-row
      :row-class-name="({ row }) => (row.isPass ? '' : 'no-pass-item')"
      show-summary
      :summary-method="handleGetTotal"
      @selection-change="handleSelectionChange"
      @select="handleSelect"
      @select-all="handleSelectAll"
    >
      <el-table-column
        type="selection"
        width="45"
        align="left"
        fixed="left"
      />
      <el-table-column label="序号" type="index" align="left" fixed="left" width="60" />
      <el-table-column
        prop="contractNum"
        label="合同编号"
        align="left"
        fixed="left"
        min-width="140"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="orderNum"
        label="订单编号"
        align="left"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="orderRowNum"
        label="订单行号"
        align="left"
        min-width="80"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="projectName"
        label="项目名称"
        align="left"
        min-width="180"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="productName"
        label="产品型号"
        header-align="left"
        sortable
        align="left"
        min-width="200"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="quantity"
        label="未发货总数量"
        align="left"
        min-width="120"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="settlementAmount"
        label="结算金额"
        align="left"
        min-width="160"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'number')"
      />
      <el-table-column
        prop="settlementAmountCny"
        label="客期变更金额（人民币）"
        align="left"
        min-width="160"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'number')"
      />
      <el-table-column
        prop="isControlled"
        label="是否受控"
        align="left"
        min-width="120"
        show-overflow-tooltip
      >
        <template v-slot="{ row }">
          <span>
            {{
              row.isControlled ? '受控' : "其他"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="advanceFrequency"
        label="客期已提前次数"
        align="left"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="delayFrequency"
        label="客期已延迟次数"
        align="left"
        min-width="130"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <el-table-column
        prop="ceddBefore"
        label="当前客期"
        sortable
        align="left"
        min-width="110"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'date')"
      />
      <el-table-column
        prop="ceddAfter"
        label="申请变更客期"
        sortable
        align="left"
        min-width="180"
        show-overflow-tooltip
      >
        <template v-slot="{ row }">
          <el-date-picker
            v-if="changeType"
            v-model="row.ceddAfter"
            type="date"
            value-format="yyyy-MM-dd"
            placeholder="选择变更日期"
            style="width: 100%"
            :picker-options="{ disabledDate }"
            @change="(change) => handleTimeChange(change, row)"
          />
          <span v-else>
            {{
              row.ceddAfter ? dayjs(row.ceddAfter).format("YYYY-MM-DD") : "-"
            }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        prop="changeDays"
        label="变更天数"
        align="left"
        min-width="80"
        show-overflow-tooltip
        :formatter="formatterValue"
      />
      <!-- 隐藏SLA建议客期 -->
      <!-- <el-table-column
        prop="slaSuggestionCedd"
        label="SLA建议客期"
        align="left"
        min-width="108"
        show-overflow-tooltip
        :formatter="(...reset) => formatterValue(...reset, 'date')"
      /> -->
    </el-table>
  </div>
</template>
<script>
import { deepCopy, formatterValue, getNum, MathMulti } from '@/libs/util';
import dayjs from 'dayjs';
import { getFestivalHoliday } from '@/API/international';
import Big from 'big.js';

export default {
  name: 'DetailedInformation',
  props: {
    changeType: {
      type: String,
      default: ''
    },
    verificationDate: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      multipleSelection: [],
      tableData: [],
      wantSetTime: '', // 想要设置的时间
      festivalHolidayList: [], // 节假日
      overseasRateToCny: 1 // 原单转人民币汇率
    };
  },
  computed: {
    isAdvance () {
      return this.changeType === 'advance';
    },
    isDelay () {
      return this.changeType === 'delay';
    }
  },
  methods: {
    formatterValue,
    dayjs,
    // 节假日
    findFestivalHoliday () {
      getFestivalHoliday()
        .then((result) => {
          let json = result.data;
          if (json.status === '200') {
            this.festivalHolidayList = json.data;
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },

    // 点击单选按钮的时候
    handleSelect (selection, row) {
      /**
       * 你可能很疑惑为什么可以这样做，
       * 在这个table中 流转的数据其实都是一个东西，
       * 所以他们的地址是一样的，
       * 所以可以使用这个进行判断是否被勾选
       */
      if (!selection.includes(row)) {
        row.isPass = true;
      }
      const amount = getNum(row.settlementAmount);
      const overseasRateToCny = getNum(this.overseasRateToCny);
      row.settlementAmountCny = MathMulti(amount, overseasRateToCny);
      // this.overseasRateToCny
      let totalCny = 0;
      selection.forEach(item => {
        totalCny = getNum(item.settlementAmountCny) + totalCny;
      });
      this.$emit('totalCny', totalCny);
    },

    // 点击全选按钮的时候
    handleSelectAll (selection) {
      if (selection.length < 1) {
        this.tableData.forEach((item) => {
          item.isPass = true;
        });
      }
    },

    // 批量的禁止选择的日期
    defaultDisabledDay (currentDate) {
      return this.festivalHolidayList.includes(
        dayjs(currentDate).format('YYYY-MM-DD')
      );
    },

    // 单行禁止选中 的日期
    disabledDate (currentDate) {
      // 仅允许选择今天以及今天之后的日期
      return dayjs(currentDate).isBefore(dayjs().startOf('day'));
    },
    handleSelectionChange (val) {
      this.multipleSelection = val;
    },
    // 获取基础数据
    setDefaultFormData (data) {
      const { detail, base } = deepCopy(data);
      console.log('======>获取基础数据', data);
      this.overseasRateToCny = base.overseasRateToCny;
      this.tableData =
        detail?.map((item) => ({
          ...item,
          isPass: true
        })) || [];
    },

    // 计算总价
    handleGetTotal (param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 1) {
          sums[index] = '总价';
          return;
        }
        if (index !== 8) {
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = Big(getNum(values.reduce((prev, curr) => {
            const value = Number(curr);
            return isNaN(value) ? prev : prev + curr;
          }, 0))).toFixed(2);
        } else {
          sums[index] = 'N/A';
        }
      });

      return sums;
    },

    // 设置时间
    handleSetTime () {
      let isHaveError = false;
      this.multipleSelection.forEach((item) => {
        // 仅校验所选日期是否为今天及之后
        if (this.disabledDate(this.wantSetTime)) {
          item.isPass = false;
          item.changeDays = 0;
          item.ceddAfter = '';
          isHaveError = true;
        } else {
          item.isPass = true;
          item.ceddAfter = this.wantSetTime;
          item.changeDays = this.getDays(item.ceddBefore, this.wantSetTime);
        }
      });
      if (isHaveError) {
        this.openTipsPopup();
      }
    },
    // 计算两个时间的差值
    getDays (start, end) {
      if (!end) return null;
      return dayjs(end).diff(dayjs(start), 'day');
    },

    // 获取表单数据
    getFormData () {
      if (this.multipleSelection.length < 1) {
        this.$message.error('请至少选中一条项目');
        return false;
      }
      try {
        this.multipleSelection.forEach((item, index) => {
          if (!item.ceddAfter) {
            throw new Error(
              `请填写详细信息勾选的第${index + 1}行的申请变更客期`
            );
          }
        });
      } catch (e) {
        this.$message.error(e.message);
        return false;
      }

      return deepCopy(
        this.multipleSelection.map((item) => ({
          ...item,
          isPass: void 0,
          errorMessage: void 0
        }))
      );
    },

    // 设置时间的时候
    handleTimeChange (change, row) {
      row.changeDays = this.getDays(row.ceddBefore, change);
      // 如果他能设置到时间就认为他设置到对的了
      row.isPass = true;
    },

    // 设置默认选择的item
    setDefaultSelection (data) {
      this.$refs.table.clearSelection();
      // 由于不能塞对象 只能双层for找对象
      data.forEach((item) => {
        let findItem = this.tableData.find(
          (row) => row.orderRowId === item.orderRowId
        );
        // 如果找到了就回显他勾选的数据
        if (findItem) {
          this.$nextTick(() => {
            // 如果时间落在可选日期中，则回显数据
            if (!this.disabledDate(item.ceddAfter)) {
              findItem.ceddAfter = item.ceddAfter;
              findItem.changeDays = item.changeDays;
            }
            this.$refs.table.toggleRowSelection(findItem, true);
            this.addNum();
          });
        }
      });
    },
    addNum () {
      let totalCny = 0;
      this.multipleSelection.forEach((item) => {
        const amount = getNum(item.settlementAmount);
        const overseasRateToCny = getNum(this.overseasRateToCny);
        item.settlementAmountCny = MathMulti(amount, overseasRateToCny);
        totalCny = getNum(item.settlementAmountCny) + totalCny;
      });
      this.$emit('totalCny', totalCny);
    },

    // 打开提示框
    openTipsPopup () {
      let noSuccessItem = '';
      this.multipleSelection.forEach((item) => {
        if (!item.isPass) {
          noSuccessItem += `${item.orderRowNum}, `;
        }
      });
      noSuccessItem = noSuccessItem.substring(0, noSuccessItem.length - 2);
      const h = this.$createElement;
      this.$msgbox({
        customClass: 'not-set-success-item-popup',
        message: h('div', null, [
          h('span', null, `勾选行号为：`),
          h(
            'span',
            { class: 'not-set-success-item-popup_title' },
            `${noSuccessItem}`
          ),
          h(
            'span',
            null,
            `; （红底高亮行）客期不符合变更标准，请重新设置客期。`
          )
        ]),
        showConfirmButton: false
      }).catch(() => { });
    }
  },
  watch: {
    // 当勾选的条数小于1的时候 清空批量设置的时间框的数据
    multipleSelection: {
      handler (multipleSelection) {
        if (multipleSelection.length < 1) {
          this.wantSetTime = '';
        }
      },
      deep: true
    },

    // 如果变更类型变化 那么需要清空他写的东西
    changeType () {
      this.tableData.forEach((item) => {
        item.ceddAfter = '';
        item.changeDays = '';
        item.isPass = true;
        item.errorMessage = '';
      });
      this.wantSetTime = '';
      this.$refs.table.clearSelection();
    }
  },

  mounted () {
    this.findFestivalHoliday();
  }
};
</script>

<style lang="scss" scoped>
.title {
  font-size: 14px;
  font-weight: bold;
  color: #383838;
  margin-bottom: 12px;
}

.search-box-line {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.search-box-line .el-button {
  font-size: 14px;
  width: 80px;
  height: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 18px;
}

.icon {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2px 6px 2px 2px;
}

.icon .el-icon-warning-outline {
  font-size: 20px;
  font-weight: bold;
  color: #808080;
}

.input-width {
  width: 270px;
}

:deep(.el-table-column--selection) {
  > .cell {
    padding-left: 10px;
    padding-right: 10px;
  }
}
.tooltips {
  color: #ff0000;
  margin-left: 20px;
}
</style>
<style lang="scss">
.no-pass-item {
  background-color: #ffe1e1 !important;

  .el-table__cell {
    background-color: #ffe1e1 !important;
  }
}
.not-set-success-item-popup {
  width: 700px;
  font-size: 14px;
  padding-bottom: 0;
  .el-message-box__btns {
    display: none;
  }
  .not-set-success-item-popup_title {
    color: #f00;
    font-weight: 700;
    font-size: 14px;
  }
  .not-set-success-item-popup_content {
    color: #f00;
  }
}
</style>
